import React from "react";
import { Camera, Image, X } from "lucide-react";

export default function ImageSourcePickerModal({ isOpen, onClose, onSelect }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl w-full max-w-sm shadow-xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
          <h2 className="text-[16px] font-bold text-gray-900">Pilih Sumber Gambar</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-slate-500 hover:bg-slate-100 transition-colors shadow-sm"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 grid grid-cols-2 gap-4">
          <button
            onClick={() => {
              onSelect("camera");
              onClose();
            }}
            className="flex flex-col items-center justify-center gap-3 p-5 rounded-2xl border border-slate-100 bg-slate-50/50 hover:bg-slate-100/70 hover:border-teal-500/30 text-teal-600 transition-all group active:scale-95"
          >
            <div className="w-12 h-12 rounded-full bg-teal-50 flex items-center justify-center text-teal-600 group-hover:scale-110 transition-transform">
              <Camera className="w-6 h-6" />
            </div>
            <span className="text-sm font-bold text-slate-700">Kamera</span>
          </button>

          <button
            onClick={() => {
              onSelect("gallery");
              onClose();
            }}
            className="flex flex-col items-center justify-center gap-3 p-5 rounded-2xl border border-slate-100 bg-slate-50/50 hover:bg-slate-100/70 hover:border-emerald-500/30 text-emerald-600 transition-all group active:scale-95"
          >
            <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-600 group-hover:scale-110 transition-transform">
              <Image className="w-6 h-6" />
            </div>
            <span className="text-sm font-bold text-slate-700">Galeri</span>
          </button>
        </div>
      </div>
    </div>
  );
}
